define("checkout/components/add-ons", ["exports", "@ember/component", "@ember/runloop", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _runloop, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/runloop",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{! Social Sets }}
  
  <div class="u--row u--row--noCollapse qa--social_sets_group u--hide--mobile" data-test-id="social-sets">
    <div class="u--col__12 u--m__b">
      <h2 class="tCH--title--h3 qa--checkout__addon--title qa--checkout__addon--socialSets" data-test-id="payment-title">
        {{t "shared_phrases.social_sets.info.header"}}
      </h2>
      <p>{{t "shared_phrases.social_sets.info.description"}}</p>
    </div>
  
    <div class="u--col__8">
      <span class="u--text--md u--text--bold qa--included_social_sets_title">
        {{t "plans.checkout.addons.social_sets.title_1"}}
      </span>
    </div>
    <div class="u--col__4 u--text--right u--m__b">
      <span class="tCH--counter__input is--readOnly qa--read_only_counter">
        {{@selectedSubscriptionPlan.numberOfSocialSets}}
      </span>
    </div>
  
    {{#if @canAddons}}
      <div class="u--col__8" data-test-id="additional-social-sets">
        <span class="u--text--md u--text--bold u--m__b__0 qa--extra_social_sets_title">
          {{t "plans.checkout.addons.social_sets.title_2"}}
        </span>
        <p class="u--text--light qa--extra_add_on_cost">
          {{#if @selectedSubscriptionPlan.isYearly}}
            {{t
              "plans.checkout.addons.social_sets.yearly_cost"
              cost=(format-currency @selectedSubscriptionPlan.additionalSocialSetCost)
            }}
          {{else}}
            {{t
              "plans.checkout.addons.social_sets.monthly_cost"
              cost=(format-currency @selectedSubscriptionPlan.additionalSocialSetCost)
            }}
          {{/if}}
        </p>
      </div>
  
      <div class="u--col__4 u--text--right">
        {{#if (and this.isMigrateAddonLoading @isOnLegacyPlan)}}
          <div class="tCH--counter__loadingWrapper">
            <Shared::LoadingSpinner id={{"socialSetsAddonsLoad"}} />
          </div>
        {{else}}
          <div class="o--btnGroup">
            <Shared::Ui::Button
              @isDisabled={{lte @additionalSocialSetCount 0}}
              @onClick={{action @onSocialSetChange -1}}
              @size="regular"
              @variant="none"
              class="tCH--counter__btn"
              data-test-id="remove-button"
            >
              {{svg-jar "minus-circle" class="o--icon--md qa--minus_circle"}}
            </Shared::Ui::Button>
            <span class="tCH--counter__input qa--input_counter" data-test-id="change">
              {{@additionalSocialSetCount}}
            </span>
            <Shared::Ui::Button
              @onClick={{action @onSocialSetChange 1}}
              @size="regular"
              @variant="none"
              class="tCH--counter__btn"
              data-test-id="add-button"
            >
              {{svg-jar "add-circle" class="o--icon--md qa--add_circle"}}
            </Shared::Ui::Button>
          </div>
        {{/if}}
      </div>
    {{/if}}
  
    {{#if (and (not this.isMigrateAddonLoading) @showSocialSetsAddonsAlert)}}
      <div class="u--col__5">
        {{#unless @isEligibleForTrial}}
          <LinkToExternal @route="subscription" rel="noopener noreferrer" target="_blank" />
        {{/unless}}
      </div>
      <div class="u--col__7 u--text--right">
        <AddOns::Change
          @effectiveDate={{@proration.socialSetEffectiveDate}}
          @type="social_set"
          @userChange={{@proration.socialSetChange}}
        />
      </div>
    {{/if}}
  </div>
  
  <div class="u--hide--mobile">
    {{#if this.showSocialSetsDisabledAlert}}
      <AlertBanner
        @text={{t
          "plans.checkout.addons.disabled_alert.social_sets"
          countToRemove=(sub @socialSetsInUse @selectedSubscriptionPlan.numberOfSocialSets)
          currentCount=@socialSetsInUse
        }}
      />
    {{else if (and (not this.isMigrateAddonLoading) (not @hasSocialSetsAddonsChanged) @showSocialSetsAddonsAlert)}}
      <MigrateAddOnsAlert @additionalSocialSetCount={{@additionalSocialSetCount}} @socialSetsInUse={{@socialSetsInUse}} />
    {{/if}}
    <hr />
  </div>
  
  {{! Users }}
  <div class="u--row u--row--noCollapse qa--users_group u--hide--mobile" data-test-id="team-members">
  
    <div class="u--col__12 u--m__b">
      <h2 class="tCH--title--h3 qa--checkout__addon--title qa--checkout__addon--users">
        {{t "shared_words.users"}}
      </h2>
      <p>{{t "plans.checkout.addons.team_members.description"}}</p>
    </div>
  
    <div class="u--col__8">
      <span class="u--text--md u--text--bold u--m__b__0 qa--included_users_title">
        {{t "plans.checkout.addons.team_members.title_1"}}
      </span>
    </div>
    <div class="u--col__4 u--text--right u--m__b">
      <span class="tCH--counter__input is--readOnly qa--read_only_counter">
        {{@selectedSubscriptionPlan.numberOfUsers}}
      </span>
    </div>
  
    {{#if @canAddons}}
      <div class="u--col__8" data-test-id="additional-team-members">
        <span class="u--text--md u--text--bold u--m__b__0 qa--extra_user_title">
          {{t "plans.checkout.addons.team_members.title_2"}}
        </span>
        <p class="u--text--light qa--extra_add_on_cost">
          {{#if @selectedSubscriptionPlan.isYearly}}
            {{t
              "plans.checkout.addons.team_members.yearly_cost"
              cost=(format-currency @selectedSubscriptionPlan.additionalUserCost)
            }}
          {{else}}
            {{t
              "plans.checkout.addons.team_members.monthly_cost"
              cost=(format-currency @selectedSubscriptionPlan.additionalUserCost)
            }}
          {{/if}}
        </p>
      </div>
      <div class="u--col__4 u--text--right">
        {{#if (and this.isMigrateAddonLoading @isOnLegacyPlan)}}
          <div class="tCH--counter__loadingWrapper">
            <Shared::LoadingSpinner id={{"usersAddonsLoad"}} />
          </div>
        {{else}}
          <div class="o--btnGroup">
            <Shared::Ui::Button
              @isDisabled={{lte @additionalTeamMemberCount 0}}
              @onClick={{action @onTeamMemberChange -1}}
              @size="regular"
              @variant="none"
              class="tCH--counter__btn"
              data-test-id="remove-button"
            >
              {{svg-jar "minus-circle" class="o--icon--md qa--minus_circle"}}
            </Shared::Ui::Button>
            <span class="tCH--counter__input qa--input_counter" data-test-id="change">
              {{@additionalTeamMemberCount}}
            </span>
            <Shared::Ui::Button
              @onClick={{action @onTeamMemberChange 1}}
              @size="regular"
              @variant="none"
              class="tCH--counter__btn"
              data-test-id="add-button"
            >
              {{svg-jar "add-circle" class="o--icon--md qa--add_circle"}}
            </Shared::Ui::Button>
          </div>
        {{/if}}
      </div>
    {{/if}}
  
    {{#if (and (not this.isMigrateAddonLoading) @showUsersAddonsAlert)}}
      <div class="u--col__5">
        {{#unless @isEligibleForTrial}}
          <LinkToExternal @route="subscription" rel="noopener noreferrer" target="_blank">
            {{t "plans.checkout.addons.see_details"}}
          </LinkToExternal>
        {{/unless}}
      </div>
      <div class="u--col__7 u--text--right">
        <AddOns::Change
          @effectiveDate={{@proration.userEffectiveDate}}
          @type="user"
          @userChange={{@proration.userChange}}
        />
      </div>
    {{/if}}
  
  </div>
  
  {{#if this.showTeamMembersDisabledAlert}}
    <AlertBanner
      @text={{t
        "plans.checkout.addons.disabled_alert.users"
        countToRemove=(sub @teamMembersInUse @selectedSubscriptionPlan.numberOfUsers)
        currentCount=@teamMembersInUse
      }}
    />
  {{else if (and (not this.isMigrateAddonLoading) (not @hasUsersAddOnsChanged) @showUsersAddonsAlert)}}
    <MigrateAddOnsAlert
      @additionalTeamMemberCount={{@additionalTeamMemberCount}}
      @teamMembersInUse={{@teamMembersInUse}}
    />
  {{/if}}
  */
  {
    "id": "hT4cQHZw",
    "block": "[[[1,\"\\n\"],[10,0],[14,0,\"u--row u--row--noCollapse qa--social_sets_group u--hide--mobile\"],[14,\"data-test-id\",\"social-sets\"],[12],[1,\"\\n  \"],[10,0],[14,0,\"u--col__12 u--m__b\"],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tCH--title--h3 qa--checkout__addon--title qa--checkout__addon--socialSets\"],[14,\"data-test-id\",\"payment-title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"shared_phrases.social_sets.info.header\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[12],[1,[28,[35,0],[\"shared_phrases.social_sets.info.description\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"u--text--md u--text--bold qa--included_social_sets_title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"plans.checkout.addons.social_sets.title_1\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4 u--text--right u--m__b\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"tCH--counter__input is--readOnly qa--read_only_counter\"],[12],[1,\"\\n      \"],[1,[30,1,[\"numberOfSocialSets\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,2],[[[1,\"    \"],[10,0],[14,0,\"u--col__8\"],[14,\"data-test-id\",\"additional-social-sets\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--md u--text--bold u--m__b__0 qa--extra_social_sets_title\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"plans.checkout.addons.social_sets.title_2\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--light qa--extra_add_on_cost\"],[12],[1,\"\\n\"],[41,[30,1,[\"isYearly\"]],[[[1,\"          \"],[1,[28,[35,0],[\"plans.checkout.addons.social_sets.yearly_cost\"],[[\"cost\"],[[28,[37,2],[[30,1,[\"additionalSocialSetCost\"]]],null]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,0],[\"plans.checkout.addons.social_sets.monthly_cost\"],[[\"cost\"],[[28,[37,2],[[30,1,[\"additionalSocialSetCost\"]]],null]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,0],[14,0,\"u--col__4 u--text--right\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"isMigrateAddonLoading\"]],[30,3]],null],[[[1,\"        \"],[10,0],[14,0,\"tCH--counter__loadingWrapper\"],[12],[1,\"\\n          \"],[8,[39,4],[[24,1,\"socialSetsAddonsLoad\"]],null,null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"o--btnGroup\"],[12],[1,\"\\n          \"],[8,[39,5],[[24,0,\"tCH--counter__btn\"],[24,\"data-test-id\",\"remove-button\"]],[[\"@isDisabled\",\"@onClick\",\"@size\",\"@variant\"],[[28,[37,6],[[30,4],0],null],[28,[37,7],[[30,0],[30,5],-1],null],\"regular\",\"none\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,8],[\"minus-circle\"],[[\"class\"],[\"o--icon--md qa--minus_circle\"]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[10,1],[14,0,\"tCH--counter__input qa--input_counter\"],[14,\"data-test-id\",\"change\"],[12],[1,\"\\n            \"],[1,[30,4]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,5],[[24,0,\"tCH--counter__btn\"],[24,\"data-test-id\",\"add-button\"]],[[\"@onClick\",\"@size\",\"@variant\"],[[28,[37,7],[[30,0],[30,5],1],null],\"regular\",\"none\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,8],[\"add-circle\"],[[\"class\"],[\"o--icon--md qa--add_circle\"]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,3],[[28,[37,9],[[30,0,[\"isMigrateAddonLoading\"]]],null],[30,6]],null],[[[1,\"    \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n\"],[41,[51,[30,7]],[[[1,\"        \"],[8,[39,11],[[24,\"rel\",\"noopener noreferrer\"],[24,\"target\",\"_blank\"]],[[\"@route\"],[\"subscription\"]],null],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__7 u--text--right\"],[12],[1,\"\\n      \"],[8,[39,12],null,[[\"@effectiveDate\",\"@type\",\"@userChange\"],[[30,8,[\"socialSetEffectiveDate\"]],\"social_set\",[30,8,[\"socialSetChange\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"u--hide--mobile\"],[12],[1,\"\\n\"],[41,[30,0,[\"showSocialSetsDisabledAlert\"]],[[[1,\"    \"],[8,[39,13],null,[[\"@text\"],[[28,[37,0],[\"plans.checkout.addons.disabled_alert.social_sets\"],[[\"countToRemove\",\"currentCount\"],[[28,[37,14],[[30,9],[30,1,[\"numberOfSocialSets\"]]],null],[30,9]]]]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[28,[37,9],[[30,0,[\"isMigrateAddonLoading\"]]],null],[28,[37,9],[[30,10]],null],[30,6]],null],[[[1,\"    \"],[8,[39,15],null,[[\"@additionalSocialSetCount\",\"@socialSetsInUse\"],[[30,4],[30,9]]],null],[1,\"\\n  \"]],[]],null]],[]]],[1,\"  \"],[10,\"hr\"],[12],[13],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[10,0],[14,0,\"u--row u--row--noCollapse qa--users_group u--hide--mobile\"],[14,\"data-test-id\",\"team-members\"],[12],[1,\"\\n\\n  \"],[10,0],[14,0,\"u--col__12 u--m__b\"],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tCH--title--h3 qa--checkout__addon--title qa--checkout__addon--users\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"shared_words.users\"],null]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,2],[12],[1,[28,[35,0],[\"plans.checkout.addons.team_members.description\"],null]],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"u--col__8\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"u--text--md u--text--bold u--m__b__0 qa--included_users_title\"],[12],[1,\"\\n      \"],[1,[28,[35,0],[\"plans.checkout.addons.team_members.title_1\"],null]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,0],[14,0,\"u--col__4 u--text--right u--m__b\"],[12],[1,\"\\n    \"],[10,1],[14,0,\"tCH--counter__input is--readOnly qa--read_only_counter\"],[12],[1,\"\\n      \"],[1,[30,1,[\"numberOfUsers\"]]],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[30,2],[[[1,\"    \"],[10,0],[14,0,\"u--col__8\"],[14,\"data-test-id\",\"additional-team-members\"],[12],[1,\"\\n      \"],[10,1],[14,0,\"u--text--md u--text--bold u--m__b__0 qa--extra_user_title\"],[12],[1,\"\\n        \"],[1,[28,[35,0],[\"plans.checkout.addons.team_members.title_2\"],null]],[1,\"\\n      \"],[13],[1,\"\\n      \"],[10,2],[14,0,\"u--text--light qa--extra_add_on_cost\"],[12],[1,\"\\n\"],[41,[30,1,[\"isYearly\"]],[[[1,\"          \"],[1,[28,[35,0],[\"plans.checkout.addons.team_members.yearly_cost\"],[[\"cost\"],[[28,[37,2],[[30,1,[\"additionalUserCost\"]]],null]]]]],[1,\"\\n\"]],[]],[[[1,\"          \"],[1,[28,[35,0],[\"plans.checkout.addons.team_members.monthly_cost\"],[[\"cost\"],[[28,[37,2],[[30,1,[\"additionalUserCost\"]]],null]]]]],[1,\"\\n\"]],[]]],[1,\"      \"],[13],[1,\"\\n    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__4 u--text--right\"],[12],[1,\"\\n\"],[41,[28,[37,3],[[30,0,[\"isMigrateAddonLoading\"]],[30,3]],null],[[[1,\"        \"],[10,0],[14,0,\"tCH--counter__loadingWrapper\"],[12],[1,\"\\n          \"],[8,[39,4],[[24,1,\"usersAddonsLoad\"]],null,null],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],[[[1,\"        \"],[10,0],[14,0,\"o--btnGroup\"],[12],[1,\"\\n          \"],[8,[39,5],[[24,0,\"tCH--counter__btn\"],[24,\"data-test-id\",\"remove-button\"]],[[\"@isDisabled\",\"@onClick\",\"@size\",\"@variant\"],[[28,[37,6],[[30,11],0],null],[28,[37,7],[[30,0],[30,12],-1],null],\"regular\",\"none\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,8],[\"minus-circle\"],[[\"class\"],[\"o--icon--md qa--minus_circle\"]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n          \"],[10,1],[14,0,\"tCH--counter__input qa--input_counter\"],[14,\"data-test-id\",\"change\"],[12],[1,\"\\n            \"],[1,[30,11]],[1,\"\\n          \"],[13],[1,\"\\n          \"],[8,[39,5],[[24,0,\"tCH--counter__btn\"],[24,\"data-test-id\",\"add-button\"]],[[\"@onClick\",\"@size\",\"@variant\"],[[28,[37,7],[[30,0],[30,12],1],null],\"regular\",\"none\"]],[[\"default\"],[[[[1,\"\\n            \"],[1,[28,[35,8],[\"add-circle\"],[[\"class\"],[\"o--icon--md qa--add_circle\"]]]],[1,\"\\n          \"]],[]]]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]]],[1,\"    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,3],[[28,[37,9],[[30,0,[\"isMigrateAddonLoading\"]]],null],[30,13]],null],[[[1,\"    \"],[10,0],[14,0,\"u--col__5\"],[12],[1,\"\\n\"],[41,[51,[30,7]],[[[1,\"        \"],[8,[39,11],[[24,\"rel\",\"noopener noreferrer\"],[24,\"target\",\"_blank\"]],[[\"@route\"],[\"subscription\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[28,[35,0],[\"plans.checkout.addons.see_details\"],null]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[]],null],[1,\"    \"],[13],[1,\"\\n    \"],[10,0],[14,0,\"u--col__7 u--text--right\"],[12],[1,\"\\n      \"],[8,[39,12],null,[[\"@effectiveDate\",\"@type\",\"@userChange\"],[[30,8,[\"userEffectiveDate\"]],\"user\",[30,8,[\"userChange\"]]]],null],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[13],[1,\"\\n\\n\"],[41,[30,0,[\"showTeamMembersDisabledAlert\"]],[[[1,\"  \"],[8,[39,13],null,[[\"@text\"],[[28,[37,0],[\"plans.checkout.addons.disabled_alert.users\"],[[\"countToRemove\",\"currentCount\"],[[28,[37,14],[[30,14],[30,1,[\"numberOfUsers\"]]],null],[30,14]]]]]],null],[1,\"\\n\"]],[]],[[[41,[28,[37,3],[[28,[37,9],[[30,0,[\"isMigrateAddonLoading\"]]],null],[28,[37,9],[[30,15]],null],[30,13]],null],[[[1,\"  \"],[8,[39,15],null,[[\"@additionalTeamMemberCount\",\"@teamMembersInUse\"],[[30,11],[30,14]]],null],[1,\"\\n\"]],[]],null]],[]]]],[\"@selectedSubscriptionPlan\",\"@canAddons\",\"@isOnLegacyPlan\",\"@additionalSocialSetCount\",\"@onSocialSetChange\",\"@showSocialSetsAddonsAlert\",\"@isEligibleForTrial\",\"@proration\",\"@socialSetsInUse\",\"@hasSocialSetsAddonsChanged\",\"@additionalTeamMemberCount\",\"@onTeamMemberChange\",\"@showUsersAddonsAlert\",\"@teamMembersInUse\",\"@hasUsersAddOnsChanged\"],false,[\"t\",\"if\",\"format-currency\",\"and\",\"shared/loading-spinner\",\"shared/ui/button\",\"lte\",\"action\",\"svg-jar\",\"not\",\"unless\",\"link-to-external\",\"add-ons/change\",\"alert-banner\",\"sub\",\"migrate-add-ons-alert\"]]",
    "moduleName": "checkout/components/add-ons.hbs",
    "isStrictMode": false
  });
  let AllFeaturesModalComponent = _exports.default = (_class = class AllFeaturesModalComponent extends _component2.default {
    get showSocialSetsDisabledAlert() {
      const hasOverageSocialSets = this.args.socialSetsInUse > this.args.selectedSubscriptionPlan?.numberOfSocialSets;
      return !this.args.canAddons && hasOverageSocialSets;
    }
    get showTeamMembersDisabledAlert() {
      const hasOverageTeamMembers = this.args.teamMembersInUse > this.args.selectedSubscriptionPlan?.numberOfUsers;
      return !this.args.canAddons && hasOverageTeamMembers;
    }
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "isMigrateAddonLoading", _descriptor, this);
      (0, _runloop.later)(() => {
        this.isMigrateAddonLoading = false;
      }, 500);
    }
    willDestroy() {
      super.willDestroy(...arguments);
      document.getElementById('socialSetsAddonsLoad')?.remove();
      document.getElementById('usersAddonsLoad')?.remove();
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "isMigrateAddonLoading", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return true;
    }
  })), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, AllFeaturesModalComponent);
});